import React from 'react';
import { useAppSocketContext } from '@/shared/hooks';
import { useAuth } from '@/shared/hooks';

function ConnectionStatusBanner() {
  const { isConnected, reconnectCountdown } = useAppSocketContext();
  const { appUser } = useAuth();

  // Only show banner for authenticated users
  if (!appUser) return null;

  // Don't show banner if connected
  if (isConnected) return null;

  // Show reconnection countdown
  if (reconnectCountdown > 0) {
    return (
      <div style={{
        position: 'fixed',
        top: 35,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'fit-content',
        maxWidth: 'calc(100% - 32px)',
        borderRadius: '3px',
        backgroundColor: '#f59e0b',
        color: 'white',
        padding: '8px 8px',
        textAlign: 'center',
        zIndex: 9999,
        fontSize: '14px',
        fontWeight: 600,
      }}>
        Connection lost. Reconnecting in {reconnectCountdown}s...
      </div>
    );
  }

  // Show disconnected state
  return (
    <div style={{
      position: 'fixed',
      top: 35,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'fit-content',
      maxWidth: 'calc(100% - 32px)',
      borderRadius: '3px',
      backgroundColor: '#ef4444',
      color: 'white',
      padding: '8px 16px',
      textAlign: 'center',
      zIndex: 9999,
      fontSize: '14px',
      fontWeight: 600,
    }}>
      Disconnected from server.
    </div>
  );
}

export default ConnectionStatusBanner;
